module.exports = __webpack_public_path__ + "img/collaborate_icon_new.9ce34f0.svg";